var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.variant=== 'A')?_c('ThreeMonthsCampaignA',{attrs:{"legacyCar":_vm.legacyCar}}):_vm._e(),(_vm.variant=== 'B')?_c('ThreeMonthsCampaignB',{attrs:{"legacyCar":_vm.legacyCar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }